import { render, staticRenderFns } from "./UniversalVoucher.vue?vue&type=template&id=187952ff&"
import script from "./UniversalVoucher.vue?vue&type=script&lang=js&"
export * from "./UniversalVoucher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports